'use strict';

import { getWSToken } from '../crm/crm-requests';
import { createMaterialAndSetBaseColor, findSelectionAndCrmData } from '../../functions';
import { parseFacing } from '../threejs/autoSelectionBoxes';
import { searchGetResults} from '../menu/search/search';
import { assignDeep, isMobile, projectMode, settingsData } from '../../settings';
import { ViewMode } from '../../common';
import { UnitCardClass } from '../cards/unitCards/UnitCardClass';
import {
  updateUnitCardProps,
} from '../cards/unitCards/unitCardFunctions';
import { createOptionsCard, openOptionsCard } from '../cards/optionsCards';
import { flatLabelPictureLiteMode } from '../components/flatLabels/flatLabels';
import { changeLangToCurrent, getCurrentLangDirection } from '../components/langSwitcher/langSwitcher';
import Notiflix from 'notiflix';
import { BaseElement } from '../interfaces/BaseElement';
import { Color, LinearSRGBColorSpace } from 'three';
import { IntersectionLegenda } from '../components/IntersectionLegenda';
import {Prepayment} from "../components/Prepayment/Prepayment";
import {Not} from "three/addons/libs/ecsy.module";

const notifyColor = new Color();
const DEFAULT_SETTINGS = {
  status: {
    active: true
  }
};

class Notification {
  constructor () {
    this.params = assignDeep(DEFAULT_SETTINGS,config.features.notifications || {});
  }

  notifyStatus(prop) {
    if (!this.params.status.active) return;
    const selectionsColors = config.resources.bundle.selectionBoxes.colorStatus;
    const selectionStatus = selectionsColors.find(selection => selection.status === prop.status.toLowerCase());
    if (selectionStatus) {
      notifyColor.setStyle(`#${selectionStatus.basic}`,LinearSRGBColorSpace);
      // const color = notifyColor.convertLinearToSRGB().getHexString();
      const color = 'fab446';
      const dir = getCurrentLangDirection();
      const notifySettings = {
        timeout: 6 * 1000,
        position: 'center-top',
        rtl: (dir !== 'ltr'),
        info:{
          background: `#${color}`,
        }
      };
      const pattern = {
        aptNum: {},
        roomNum: {},
        floor: {}
      };
      const dictionaryKey = prop.status === 'Saved' ? 'savedNotificationText' : 'soldNotificationText';
      Object.keys(config.dictionary[dictionaryKey]).forEach(lang => {
        pattern.aptNum[lang] = prop.propNum;
        pattern.roomNum[lang] = prop.roomNum;
        pattern.floor[lang] = prop.floorNum;
      });

      const text = changeLangToCurrent(dictionaryKey,[pattern]);
      const html = Notification.template(text,dictionaryKey);
      Notiflix.Notify.merge(notifySettings);
      Notiflix.Notify.info(html.innerHTML);
    }
  }

  static template(message,dictionaryKey) {
    const container = new BaseElement()
      .addClass('notification')
      .DOMElement;
    new BaseElement('span')
      .addClass('notification__text','language-string')
      .innerHtml(message)
      .addAttribute('data-dictionary',dictionaryKey)
      .appendTo(container);

    return container;
  }

}

class PushEvents extends Notification{
  constructor () {
    super();
  }

  updateProp(prop) {
    const {selectedMesh,crmDataOfFlat} = findSelectionAndCrmData(prop.engineId);
    const prevStatus = crmDataOfFlat.status;
    parseFacing(prop);
    Object.entries(prop).forEach(([key,value]) => {
      if (key === 'status' && (crmDataOfFlat[key] !== value &&
        (value === 'Saved' || value === 'Sold'))) {
        this.notifyStatus(prop);
      }

      if (key === 'status' && crmDataOfFlat[key] !== value) {
        value === 'InSaving'
          ? Prepayment.disable(prop)
          : Prepayment.enable(prop);
      }

      crmDataOfFlat[key] = value;
    });

    const needsEdges = prevStatus !== 'Available' && crmDataOfFlat.status === 'Available';

    if (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('picture')) {
      const label = selectedMesh.getObjectByName('label');
      label.element.remove();
      label.removeFromParent();
      flatLabelPictureLiteMode(selectedMesh);
    } else {
      createMaterialAndSetBaseColor(selectedMesh,needsEdges);
    }

    const outline = selectedMesh.getObjectByName('Outline');
    if (outline && crmDataOfFlat.status !== 'Available') {
      outline.removeFromParent();
    }

    if (settingsData.activeViewMode !== ViewMode.Orbit) {
      searchGetResults();
      const unitCard = UnitCardClass.findCard(prop.engineId);
      const optionCard = document.querySelector(`.options-card[data-engineid="${prop.engineId}"]`);
      if (unitCard) {
        updateUnitCardProps(unitCard,prop);
      }

      if (optionCard) {
        const object = prop;
        optionCard.remove();
        if (isMobile) {
          openOptionsCard({object, settings: config, isForeCompare: false});
        } else {
          createOptionsCard({object, settings: config, isForeCompare: false});
        }
      }
    }
  }
}

export class PushNotifications extends PushEvents {

  constructor () {
    super();
    this.connected = false;
  }

  async connect() {
    let response;
    try {
      response = await getWSToken();
    }catch (e) {
      console.log(`WS Token: Can't get the token. Error: ` + e.message);
      return;
    }

    this.token = response.data;
    if (!this.token) return;

    try {
      this.webSocket = new WebSocket('wss://wss.bmby.com:8443/events?tokenId=' + this.token);
    } catch (e) {
      throw new Error('Push notifications: ' + e.message);
    }

    this.webSocket.addEventListener('open', this.openHandler.bind(this));
    this.webSocket.addEventListener('message', this.messageHandler.bind(this));
  }

  openHandler() {
    this.connected = true;
    console.log('Connected');
  }

  messageHandler(e) {
    const message = JSON.parse(e.data);
    if (message.type !== 6060 || !message.data.objData) return;

    switch (message.data.objData.eventType) {
      case 'updateProp':
        message.data.objData.propData.forEach(prop => this.updateProp(prop));
        setTimeout(() => {IntersectionLegenda.build()}, 1000);
        break;
      case 'generalUpdate':
        break;
    }
  }

}